import React, { forwardRef } from 'react';
// import './Receipt.css'; // Removed to inline styles for offline support

const receiptStyles = `
/* Receipt Styles (Thermal Printer Format) */
.receipt {
    font-family: 'Courier New', monospace;
    font-size: 12px;
    width: 300px;
    padding: 20px;
    background: white;
    color: black;
}

.receipt-header {
    text-align: center;
    margin-bottom: 10px;
}

.receipt-brand {
    font-size: 24px;
    font-weight: bold;
    margin: 0 0 5px 0;
}

.receipt-branch {
    font-size: 14px;
    font-weight: bold;
    margin: 0;
}

.receipt-address,
.receipt-phone {
    font-size: 11px;
    margin: 2px 0;
}

.receipt-divider {
    font-family: 'Courier New', monospace;
    text-align: center;
    color: #333;
    margin: 8px 0;
    white-space: pre;
}

.receipt-info {
    margin-bottom: 10px;
}

.receipt-row {
    display: flex;
    justify-content: space-between;
    margin: 3px 0;
}

.receipt-items {
    margin-bottom: 10px;
}

.receipt-item-header {
    display: flex;
    justify-content: space-between;
    font-weight: bold;
    margin-bottom: 5px;
}

.receipt-item {
    display: flex;
    justify-content: space-between;
    margin: 4px 0;
}

.item-name {
    flex: 2;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.item-qty {
    width: 40px;
    text-align: center;
}

.item-price {
    width: 60px;
    text-align: right;
}

.receipt-totals {
    margin-bottom: 10px;
}

.receipt-row.total {
    font-weight: bold;
    font-size: 14px;
    margin-top: 5px;
}

.receipt-footer {
    text-align: center;
    margin-top: 15px;
    font-size: 11px;
}

.receipt-footer p {
    margin: 3px 0;
}

/* Print-specific styles */
@media print {
    .receipt {
        margin: 0;
        padding: 10px;
        width: 100%;
        max-width: 80mm;
    }

    .receipt-brand {
        font-size: 18px;
    }

    .receipt-divider {
        font-size: 10px;
    }
}
`;

const Receipt = forwardRef(({ order }, ref) => {
    const formatDate = (date) => {
        if (!date) return '';
        return new Date(date).toLocaleString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        });
    };

    return (
        <div className="receipt" ref={ref}>
            <style>{receiptStyles}</style>
            {!order ? (
                <div style={{ textAlign: 'center', padding: '20px' }}>
                    <p>Loading order details...</p>
                </div>
            ) : (
                <>
                    <div className="receipt-header">
                        <img src="/cravings_logo_bw.png" alt="Cravings" style={{ width: '150px', marginBottom: '10px' }} />
                        <p className="receipt-branch">{order.branch?.name || 'Main Branch'}</p>
                        <p className="receipt-address">{order.branch?.address}</p>
                        <p className="receipt-phone">{order.branch?.phone}</p>
                    </div>

                    <div className="receipt-divider">================================</div>

                    <div className="receipt-info">
                        <div className="receipt-row">
                            <span>Order #:</span>
                            <span>{order.orderNumber}</span>
                        </div>
                        {(order.offline_id || order.offlineId) && (
                            <div className="receipt-row">
                                <span>Offline ID:</span>
                                <span>{order.offline_id || order.offlineId}</span>
                            </div>
                        )}
                        <div className="receipt-row">
                            <span>Date:</span>
                            <span>{formatDate(order.createdAt)}</span>
                        </div>
                    </div>

                    <div className="receipt-divider">================================</div>

                    <div className="receipt-items">
                        <div className="receipt-item-header">
                            <span className="item-name">Item</span>
                            <span className="item-qty">Qty</span>
                            <span className="item-price">Price</span>
                        </div>
                        <div className="receipt-divider">--------------------------------</div>

                        {order.items?.map((item, index) => (
                            <div key={index} className="receipt-item">
                                <span className="item-name">{item.itemName}</span>
                                <span className="item-qty">{item.quantity}</span>
                                <span className="item-price">Rs. {parseFloat(item.totalPrice).toFixed(2)}</span>
                            </div>
                        ))}
                    </div>

                    <div className="receipt-divider">--------------------------------</div>

                    <div className="receipt-totals">
                        <div className="receipt-row">
                            <span>Subtotal:</span>
                            <span>Rs. {parseFloat(order.subtotal).toFixed(2)}</span>
                        </div>
                        <div className="receipt-row">
                            <span>Tax ({order.taxRate}%):</span>
                            <span>Rs. {parseFloat(order.taxAmount).toFixed(2)}</span>
                        </div>
                        <div className="receipt-divider">--------------------------------</div>
                        <div className="receipt-row total">
                            <span>TOTAL:</span>
                            <span>Rs. {parseFloat(order.totalAmount).toFixed(2)}</span>
                        </div>
                    </div>

                    <div className="receipt-divider">================================</div>

                    <div className="receipt-footer">
                        <p>Thank you for your order!</p>
                        <p>Please come again 😊</p>
                    </div>
                </>
            )}
        </div>
    );
});

Receipt.displayName = 'Receipt';

export default Receipt;
